import numeric from "../../utils/NumericFunction";

export const getTodayDate = (digits_en_or_fa) => {
  const date = new Date().toLocaleDateString("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  })
  if (digits_en_or_fa === 'en') {
    return numeric.p2e(date)
  }
  return date
}

export function convertToValue(hours, minutes, seconds) {
  debugger
  let totalMinutes = ((+hours * 60) + +minutes + (+seconds / 60));
  const totalHours = totalMinutes / 60;

  return totalHours
}